import { clearPreviewProfileFlag } from "./profiles";

export const PREVIEW_ENV_ID = "preview-env-00000000";

const PREVIEW_MODE_STORAGE_KEY = "previewMode";

let cachedEnabled: boolean | null = null;

export function isPreviewModeEnabled(): boolean {
  if (cachedEnabled !== null) return cachedEnabled;
  try {
    cachedEnabled = localStorage.getItem(PREVIEW_MODE_STORAGE_KEY) === "true";
  } catch {
    cachedEnabled = false;
  }
  return cachedEnabled;
}

export function enablePreviewMode(): void {
  localStorage.setItem(PREVIEW_MODE_STORAGE_KEY, "true");
  // Full reload so module-level caches (the runtime flag, the synthetic
  // graph) reset cleanly and every read kind goes through the preview
  // handlers.
  window.location.reload();
}

export function disablePreviewMode(): void {
  localStorage.removeItem(PREVIEW_MODE_STORAGE_KEY);
  clearPreviewProfileFlag();
  // Full reload so module-level caches (the runtime flag, the synthetic
  // graph) reset cleanly and every read kind goes back to the network.
  window.location.reload();
}

// Clears the preview-mode flag without reloading. Use this on login paths so
// every authenticated session starts with preview mode off, regardless of
// whether the prior session was logged out due to inactivity, a manual signout,
// or simply closing the tab while the flag was set.
export function clearPreviewModeFlag(): void {
  try {
    localStorage.removeItem(PREVIEW_MODE_STORAGE_KEY);
  } catch {
    // localStorage may be unavailable (private mode, disabled cookies); the
    // module-level cache still wins for the rest of the session.
  }
  cachedEnabled = null;
  clearPreviewProfileFlag();
}

// Clears the preview-mode flag only on a real auth-state transition. Firebase's
// onAuthStateChanged listener fires once with the *restored* auth state when
// the listener registers — that initial read looks identical to a sign-in but
// is just the continuation of an existing session. Treating it as a transition
// would wipe a flag the user just set and then refreshed to apply.
export function clearPreviewModeOnAuthTransition(
  previous: boolean | undefined,
  current: boolean,
): void {
  if (previous === undefined || previous === current) return;
  clearPreviewModeFlag();
}

export function __resetPreviewModeCache(): void {
  cachedEnabled = null;
}
